import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Clock, Sparkles } from "lucide-react";

export const Hero = () => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 via-transparent to-transparent" />

    <div className="relative mx-auto max-w-7xl px-6 py-20 md:py-28">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <span className="text-xs text-slate-400 uppercase tracking-wider">We help with</span>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1 rounded-full bg-pink-500/20 text-pink-400 text-xs font-medium">Instagram</span>
            <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-400 text-xs font-medium">Facebook</span>
            <span className="px-3 py-1 rounded-full bg-slate-500/20 text-slate-300 text-xs font-medium">TikTok</span>
            <span className="px-3 py-1 rounded-full bg-red-500/20 text-red-400 text-xs font-medium">YouTube</span>
            <span className="px-3 py-1 rounded-full bg-sky-500/20 text-sky-400 text-xs font-medium">X</span>
          </div>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
          Social Media Account
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
            Suspended or Disabled?
          </span>
        </h1>

        <p className="mt-6 text-lg md:text-xl text-slate-300 leading-relaxed max-w-2xl">
          We build appeal documentation that platforms can&rsquo;t dismiss in 30 seconds — for Instagram, Facebook, TikTok, YouTube, and X. Independent, US-based, and structured around each platform&rsquo;s specific policies.
        </p>
        <p className="mt-3 text-xs text-slate-500 max-w-2xl">
          Independent documentation service. Not affiliated with any platform. Outcomes are determined by each platform — never guaranteed. <a href="#disclaimer" className="underline hover:text-slate-300">Full disclaimer ↓</a>
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link
            to="/analyze"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-slate-950 px-8 py-4 text-base font-semibold shadow-xl hover:bg-slate-100 transition"
            data-testid="hero-cta-primary"
          >
            <Sparkles className="w-5 h-5" />
            Analyze My Suspension (Free)
            <ArrowRight className="w-5 h-5" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-8 py-4 text-base font-medium hover:bg-white/5 transition"
            data-testid="hero-cta-secondary"
          >
            Check If You Qualify
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-8 text-sm text-slate-400">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-400" />
            <span>Free diagnostic · 60 seconds · no email required</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-blue-400" />
            <span>Response within 24 hours</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
